'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _InputConstants = require('./InputConstants');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createWarningMessage = function createWarningMessage(propName) {
  return {
    message: 'UITextArea: the ' + propName + ' prop has been deprecated. Please use `UICharacterCounter` instead.',
    key: 'UITextArea: ' + propName + ' prop'
  };
};

var UITextArea = _react2.default.createClass({
  displayName: 'UITextArea',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    cols: _react.PropTypes.number,
    counter: (0, _deprecated2.default)(_react.PropTypes.bool, createWarningMessage),
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    I18n: _react.PropTypes.object,
    inputRef: _refObject2.default,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    resize: _react.PropTypes.oneOf(['vertical', 'horizontal', true, false]),
    rows: _react.PropTypes.number,
    style: _react.PropTypes.object,
    styled: _react.PropTypes.bool.isRequired,
    _textAreaHeightStyle: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      resize: 'vertical',
      styled: true,
      value: ''
    };
  },
  getStyle: function getStyle(_ref) {
    var _textAreaHeightStyle = _ref._textAreaHeightStyle,
        style = _ref.style;

    return _extends({}, _textAreaHeightStyle, style);
  },
  renderCounter: function renderCounter(_ref2) {
    var I18n = _ref2.I18n,
        value = _ref2.value;

    var count = value ? value.length : 0;
    return _react2.default.createElement(
      'span',
      {
        className: 'private-text-area__counter',
        'aria-live': 'polite',
        'aria-atomic': 'false'
      },
      count === 1 ? I18n.text('salesUI.UITextArea.characterCounter.one', { count: count }) : I18n.text('salesUI.UITextArea.characterCounter.other', { count: count })
    );
  },
  renderTextarea: function renderTextarea(_ref3, _ref4) {
    var inputRef = _ref3.inputRef,
        rest = _ref3.rest,
        value = _ref3.value;
    var computedClassName = _ref4.computedClassName,
        computedStyle = _ref4.computedStyle;

    return _react2.default.createElement('textarea', _extends({}, rest, {
      className: computedClassName,
      ref: (0, _Functions.wrapRefObject)(inputRef),
      style: computedStyle,
      value: value
    }));
  },
  render: function render() {
    var _props = this.props,
        _textAreaHeightStyle = _props._textAreaHeightStyle,
        className = _props.className,
        counter = _props.counter,
        error = _props.error,
        I18n = _props.I18n,
        inputRef = _props.inputRef,
        resize = _props.resize,
        style = _props.style,
        styled = _props.styled,
        use = _props.use,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['_textAreaHeightStyle', 'className', 'counter', 'error', 'I18n', 'inputRef', 'resize', 'style', 'styled', 'use', 'value']);

    var computedClassName = (0, _reactUtils.classNames)('form-control', 'private-form__control', 'private-text-area', className, _InputConstants.INPUT_SIZE_OPTIONS[this.context.fieldSize], _InputConstants.USE_CLASSES[use], {
      'private-text-area--with-counter': counter,
      'private-form__control--unstyled': !styled,
      'private-form__control--error': error,
      'private-text-area--no-resize': resize === false,
      'private-text-area--vertical-resize': resize === 'vertical',
      'private-text-area--horizontal-resize': resize === 'horizontal'
    });

    var computedStyle = this.getStyle({ _textAreaHeightStyle: _textAreaHeightStyle, style: style });
    var renderedTextarea = this.renderTextarea({ inputRef: inputRef, rest: rest, value: value }, { computedClassName: computedClassName, computedStyle: computedStyle });

    if (counter) {
      return _react2.default.createElement(
        'div',
        { className: 'private-text-area__counter-wrapper' },
        renderedTextarea,
        this.renderCounter({ I18n: I18n, value: value })
      );
    }
    return renderedTextarea;
  }
});

exports.default = (0, _ShareInput2.default)((0, _Controllable2.default)((0, _Translatable2.default)(UITextArea)));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UITextArea.js
// module id = 367
// module chunks = 0